import { createFileRoute } from "@tanstack/react-router";

import { GradingAccuracyPage } from "../../../workspaces/label/pages/GradingAccuracyPage";

export const Route = createFileRoute("/_console/label/qc/accuracy")({
  component: GradingAccuracyPage,
});
